import { API, authClient } from '../index'

export const getInitUrlCalendar = () => {
  return authClient().post(`${API}/calendar/`)
}

export const postTokensOauth = (code, userId) => {
  return authClient().post(`${API}/calendar/token/${userId}`, { code })
}

export const getCalendarLists = (userId) => {
  return authClient().post(`${API}/calendar/lists/${userId}`)
}

export const insertCalendar = (userId) => {
  return authClient().post(`${API}/calendar/lists/insert/${userId}`)
}

export const grantPermissionsCalendar = (userId, name, surname, email) => {
  return authClient().post(`${API}/calendar/permissions/${userId}`, { name, surname, email });
}